const expandPainelButtonFormActions = {
  more: 'See more',
  less: 'See less'
};

export default expandPainelButtonFormActions;
